import { registerOperation } from './shared';
function registerQuery(options) {
  return registerOperation('query', options, true);
}
function registerMutation(options) {
  return registerOperation('mutation', options, true);
}
export { registerQuery, registerMutation };